const utilities = {
    computed: {
        chart_style () {
            return {
                width: "100%",
                height: "200px",
                position: "relative"
            }
        }
    },
    methods: {
        debug_message (message, debug) {
            console.log(message, debug)
        }
    }
}

export default utilities
